<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="program_list_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Тип образования</label>
                        <select class="input sm:ml-2" v-model="education_type_param">
                            <option value="">Все</option>
                            <option v-for="(item, index) in education_type_items" :key="index" :value="item.value">{{item.key}}</option>
                        </select>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28 break-words">Тип образовательной программы</label>
                        <select class="input sm:ml-2" v-model="education_program_type_param">
                            <option value="">Все</option>
                            <option v-for="(item, index) in education_program_type_items" :key="index" :value="item.value">{{item.key}}</option>
                        </select>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Документ об образовании</label>
                        <select class="input sm:ml-2" v-model="document_param">
                            <option value="">Все</option>
                            <option v-for="(item, index) in document_items" :key="index" :value="item.value">{{item.key}}</option>
                        </select>
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;_ProccessPrograms()">Запросить данные заново</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewProgram')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">Создать новую программу</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#program_list_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-[2000px] mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + programs.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{programCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="card py-0 w-[90%] max-w-[2000px] mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th>Название</th>
                    <th>Аббревиатура</th>
                    <th>Кол-во часов</th>
                    <th>Направленность</th>
                    <th>Тип образования</th>
                    <th>Тип образовательной программы</th>
                    <th>Документ об образовании</th>
                    <th>Профессия</th>
                    <th>Тем. план</th>
                    <th>Файл</th>
                    <th></th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="(program, index) in programs" :key="index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td v-if="$root.HasRole($store.state.adminRole)">{{program.ID}}</td>
                        <td>{{program.Title}}</td>
                        <td>{{program.Abbreviation}}</td>
                        <td>{{program.HourNumber}}</td>
                        <td>{{program.Directivity}}</td>
                        <td>{{program.EducationType}}</td>
                        <td>{{program.EducationProgramType}}</td>
                        <td>{{program.Document}}</td>
                        <td>{{program.Profession.Title.trim() !== "" ? `${program.Profession.Title.trim()}[${program.Profession.Code}]` : ''}}</td>
                        <td class="text-center cursor-pointer font-bold" @click="SeeProgramThemes(index)">{{program.Themes.length > 0 ? program.Themes.length : 'не заполнен'}}</td>
                        <td class="text-center text-gradient" v-if="program.FileName !== null && program.FileName.trim() !== ''"><button @click="DownloadProgramFile(program.ID, program.FileName)">{{program.FileName}}</button></td>
                        <td v-else></td>
                        <th>
                            <button class="text-blue-600" @click="SeeProgram(index)" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                </svg>
                            </button>
                        </th>
                        <th>
                            <button class="text-red-600" @click="DeleteProgram(program.ID)" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal dark:text-white" id="NewProgram" @click="$root.HideModal('#NewProgram')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <form class="modal-dialog" @submit="NewProgram" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новая программа</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewProgram')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Название <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="program_title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Аббревиатура</label>
                    <input type="text" class="input sm:ml-auto" ref="program_abbreviation">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во часов <b class="text-red-600">*</b></label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="program_hour_number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Направленность</label>
                    <input type="text" class="input sm:ml-auto" ref="program_directivity">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип образования <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="program_education_type">
                        <option v-for="(item, index) in education_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип образовательной программы <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="program_education_program_type">
                        <option v-for="(item, index) in education_program_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Документ об образовании <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="program_document">
                        <option v-for="(item, index) in document_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Профессия</label>
                    <input type="text" class="input sm:ml-auto" ref="program_profession_title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Код профессии</label>          
                    <input type="text" class="input sm:ml-auto" ref="program_profession_code">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewProgram')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewProgram')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeProgram" @click="$root.HideModal('#ChangeProgram')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <form class="modal-dialog" @submit="ChangeProgram" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных программы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeProgram')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Название <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="current_program_title" :value="currentProgram.Title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Аббревиатура</label>
                    <input type="text" class="input sm:ml-auto" ref="current_program_abbreviation" :value="currentProgram.Abbreviation">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во часов <b class="text-red-600">*</b></label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="current_program_hour_number" :value="currentProgram.HourNumber">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Направленность</label>
                    <input type="text" class="input sm:ml-auto" ref="current_program_directivity" :value="currentProgram.Directivity">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип образования <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="current_program_education_type" :value="currentProgram.EducationType">
                        <option v-for="(item, index) in education_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип образовательной программы <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="current_program_education_program_type" :value="currentProgram.EducationProgramType">
                        <option v-for="(item, index) in education_program_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Документ об образовании <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="current_program_document" :value="currentProgram.Document">
                        <option v-for="(item, index) in document_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Профессия</label>
                    <input type="text" class="input sm:ml-auto" ref="current_program_profession_title" :value="currentProgram.Profession.Title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Код профессии</label>          
                    <input type="text" class="input sm:ml-auto" ref="current_program_profession_code" :value="currentProgram.Profession.Code">
                </div>
                <div  class="form-group w-full my-2">
                    <label class="input-label">Файл</label> 
                    <file-input class="sm:ml-auto" :filename="currentProgram.FileName" id="pf" ref="pf" />
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeProgram')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeProgram')">Изменить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="SeeThemes" @click="$root.HideModal('#SeeThemes')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <div class="modal-dialog !max-w-5xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр тем. плана программы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <table class="sys-table mb-2">
                    <thead class="!-top-4 z-[4002]">
                        <th>
                            <button class="rounded-button" @click="$root.HideModal('#SeeThemes');$root.ShowModal('#NewTheme')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                        <th>№</th>
                        <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                        <th>Модуль</th>
                        <th>Название</th>
                        <th>Вид занятия</th>
                        <th>
                        </th>
                        <th>
                        </th>
                        <th>
                            <button class="text-red-600" @click="DeleteMultipleThemes">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(theme, index) in currentProgram.Themes" :key="index">
                            <th>
                                <div class="flex flex-col justify-center items-center h-full">
                                    <input class="checkbox before:!bg-secondary dark:before:!bg-secondary" type="checkbox" :ref="'delete_theme_' + index">
                                </div>
                            </th>
                            <th>{{index + 1}}</th>
                            <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{theme.ID}}</td>
                            <td>{{theme.Module}}</td>
                            <td>{{theme.Title}}</td>
                            <td>{{theme.Type}}</td>
                            <th>
                                <button class="text-blue-600" @click="$root.HideModal('#SeeThemes');SeeProgramTheme(index, '#ChangeTheme')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                    </svg>
                                </button>
                            </th>
                            <th>
                                <button class="text-orange-600" @click="$root.HideModal('#SeeThemes');SeeProgramTheme(index, '#ChangeThemePosition')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
                                    </svg>
                                </button>
                            </th>
                            <th>
                                <button class="text-red-600" @click="DeleteTheme(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="NewTheme" @click="$root.HideModal('#NewTheme');$root.ShowModal('#SeeThemes')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <form class="modal-dialog" @submit="NewTheme" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Добавление темы в тем. план</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewTheme');$root.ShowModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Модуль</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="theme_module">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Название</label>
                    <input type="text" class="input sm:ml-auto" ref="theme_title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Вид занятия</label>
                    <select class="input sm:ml-auto" ref="theme_type">
                        <option v-for="(item, index) in thematic_plan_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Объём часов</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="theme_hour_number">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewTheme');$root.ShowModal('#SeeThemes')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewTheme')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeTheme" @click="$root.HideModal('#ChangeTheme');$root.ShowModal('#SeeThemes')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <form class="modal-dialog" @submit="ChangeTheme" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение темы в тем. плане</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeTheme');$root.ShowModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Модуль</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="current_theme_module" :value="currentTheme.Module">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Название</label>
                    <input type="text" class="input sm:ml-auto" ref="current_theme_title" :value="currentTheme.Title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Вид занятия</label>
                    <select class="input sm:ml-auto" ref="current_theme_type" :value="currentTheme.Type">
                        <option v-for="(item, index) in thematic_plan_type_items" :key="index" :value="item.value">{{item.key}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeTheme');$root.ShowModal('#SeeThemes')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeTheme')">Изменить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeThemePosition" @click="$root.HideModal('#ChangeThemePosition');$root.ShowModal('#SeeThemes')" v-if="$root.HasRole($store.state.methodistRole) || $root.HasRole($store.state.adminRole)">
        <form class="modal-dialog" @submit="ChangeThemePosition" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение позиции темы в тем. плане</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeThemePosition');$root.ShowModal('#SeeThemes')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-row items-center justify-center">
                    <p class="input w-20">{{currentProgram.Themes.indexOf(currentTheme) + 1}}</p>
                    <p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
                        </svg>
                    </p>
                    <div>
                        <input type="number" min="1" class="input w-20" ref="current_theme_position" :value="currentProgram.Themes.indexOf(currentTheme) + 1">
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeThemePosition');$root.ShowModal('#SeeThemes')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeThemePosition')">Изменить</button>
            </div>
        </form>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import FileInput from '@/components/FileInput'

export default {
    components: {
        Navigation,
        FileInput
    },
    data() {
        return {
            education_type_items: [],
            education_program_type_items: [],
            document_items: [],
            thematic_plan_type_items: [],
            search_param: "",
            education_type_param: "",
            education_program_type_param: "",
            document_param: "",
            programs: [],
            programCount: 0,
            elementNumber: 25,
            pageNumber: 0,
            pagesCount: 0,
            currentProgram: {
                ID: "",
                Title: "",
                Abbreviation: "",
                HourNumber: 0,
                Directivity: "",
                Document: "",
                EducationType: "",
                EducationProgramType: "",
                FileName: "",
                Profession: {
                    Title: "",
                    Code: ""
                },
                Themes: []
            },
            currentTheme: {
                ID: "",
                Module: 0,
                Number: 0,
                Title: "",
                Type: "",
                Volume: 1,
            },
            navigationKey: "nav",
            title: "Список программ"
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this._ProccessPrograms()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this._ProccessPrograms()
        },
        ClearParams() {
            this.search_param = ""
            this.education_type_param = ""
            this.education_program_type_param = ""
            this.document_param = ""
        },
        async _SelectData() {
            let res = await fetch(this.$store.state.aeApiAddr + "/v1.0/selects/type_document", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.document_items = res.data.select.variants

            res = await fetch(this.$store.state.aeApiAddr + "/v1.0/selects/type_of_educational_program", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.education_program_type_items = res.data.select.variants

            res = await fetch(this.$store.state.aeApiAddr + "/v1.0/selects/type_of_education", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.education_type_items = res.data.select.variants

            res = await fetch(this.$store.state.aeApiAddr + "/v1.0/selects/thematic_plan/type_of_occupation", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.thematic_plan_type_items = res.data.select.variants
        },
        async _ProccessPrograms() {
            this.$root.StartLoading()

            let res = await fetch(this.$store.state.aeApiAddr + `/v1.0/programs/list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&search=${this.search_param}&type_document=${this.document_param}&type_of_educational_program=${this.education_program_type_param}&type_of_education=${this.education_type_param}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.programCount = res.data.collections

            this.pagesCount = Math.ceil(this.programCount / this.elementNumber)

            let programs = []
            for (var i in res.data.programs) {
                var program = res.data.programs[i]

                let thematic_plan = []

                for (var j in program.thematic_plan.themes) {
                    var theme = program.thematic_plan.themes[j]

                    if (theme === undefined || theme === null) {
                        continue
                    }

                    thematic_plan.push({
                        ID: theme.id,
                        Module: theme.module,
                        Number: theme.number,
                        Title: theme.title,
                        Type: theme.type,
                        Volume: theme.volume
                    })
                }

                programs.push({
                    ID: program.id,
                    Title: program.title,
                    Abbreviation: program.abbreviation,
                    HourNumber: program.number_of_hours,
                    Directivity: program.directivity,
                    Document: program.type_document,
                    EducationType: program.type_of_education,
                    EducationProgramType: program.type_of_educational_program,
                    FileName: program.file_name,
                    Profession: {
                        Title: program.profession.title,
                        Code: program.profession.code
                    },
                    Themes: thematic_plan
                })
            }

            this.programs = programs

            this.$root.EndLoading()
        },
        NewProgram(e) {
            e.preventDefault()

            let form = e.target

            let title = this.$refs.program_title.value
            let abbreviation = this.$refs.program_abbreviation.value
            let hour_number = this.$refs.program_hour_number.value
            let directivity = this.$refs.program_directivity.value
            let education_type = this.$refs.program_education_type.value
            let education_program_type = this.$refs.program_education_program_type.value
            let document = this.$refs.program_document.value
            let profession_title = this.$refs.program_profession_title.value
            let profession_code = this.$refs.program_profession_code.value

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    title: title,
                    abbreviation: abbreviation,
                    number_of_hours: Number(hour_number),
                    directivity: directivity,
                    type_of_education: education_type,
                    type_of_educational_program: education_program_type,
                    type_document: document,
                    profession: {
                        title: profession_title,
                        code: profession_code
                    }
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Программа успешно добавлена", "success")
                this._ProccessPrograms()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteProgram(id) {
            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({ id: id })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Программа успешно удалена", "success")
                this._ProccessPrograms()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        UpdateCurrentProgram(index) {
            this.currentProgram = this.programs[index]
        },
        SeeProgram(index) {
            this.currentProgram = this.programs[index]
            this.$root.ShowModal("#ChangeProgram")
        },
        SeeProgramThemes(index) {
            this.currentProgram = this.programs[index]
            this.$root.ShowModal("#SeeThemes")
        },
        SeeProgramTheme(index, selector) {
            this.currentTheme = this.currentProgram.Themes[index]
            this.$root.ShowModal(selector)
        },
        ChangeProgram(e) {
            e.preventDefault()

            let title = this.$refs.current_program_title.value
            let abbreviation = this.$refs.current_program_abbreviation.value
            let hour_number = this.$refs.current_program_hour_number.value
            let directivity = this.$refs.current_program_directivity.value
            let education_type = this.$refs.current_program_education_type.value
            let education_program_type = this.$refs.current_program_education_program_type.value
            let document = this.$refs.current_program_document.value
            let profession_title = this.$refs.current_program_profession_title.value
            let profession_code = this.$refs.current_program_profession_code.value

            

            if (this.$refs.pf.IsChanged()) {
                let file_data = this.$refs.pf.GetFileData()
                if (file_data.length > 0) {

                    let data = new FormData()

                    data.append("file", file_data[0])

                    data.append("id", this.currentProgram.ID)

                    fetch(this.$store.state.filesApiAddr + "/v1.0/ae/programs/", {
                        method: "POST",
                        headers: {
                            'Authorization': `Bearer ${this.$root.GetToken()}`,
                        },
                        body: data
                    })
                    .then(response => response.json())
                    .then(res => {
                        if (this.$root.HandleFetchError(res)) return
                        this.$root.ShowToast("Файл программы успешно изменён", "success")
                        this.$refs.pf.ResetIsChanged()
                        this._ProccessPrograms()
                    })
                    .catch(error => {
                        this.$root.Fatal()
                    })
                } else {
                    if (this.currentProgram.FileName !== null && this.currentProgram.FileName.trim() !== "") {
                        fetch(this.$store.state.filesApiAddr + "/v1.0/ae/programs/", {
                            method: "DELETE",
                            headers: {
                                'Authorization': `Bearer ${this.$root.GetToken()}`,
                                'Content-Type': 'text/json;charset=utf-8'
                            },
                            body: JSON.stringify({id: this.currentProgram.ID})
                        })
                        .then(response => response.json())
                        .then(res => {
                            if (this.$root.HandleFetchError(res)) return
                            this.$root.ShowToast("Файл программы успешно удалён", "success")
                            this.$refs.pf.ResetIsChanged()
                            this._ProccessPrograms()
                        })
                        .catch(error => {
                            this.$root.Fatal()
                        })
                    }
                }
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentProgram.ID,
                    title: title,
                    abbreviation: abbreviation,
                    number_of_hours: Number(hour_number),
                    directivity: directivity,
                    type_of_education: education_type,
                    type_of_educational_program: education_program_type,
                    type_document: document,
                    profession: {
                        title: profession_title,
                        code: profession_code
                    }
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные программы успешно изменены", "success")
                this._ProccessPrograms()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        async DownloadProgramFile(id, filename) {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/programs/by_id/${id}`, {
                    method: "GET",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось скачать файл программы", "error")
                })

                var result = await res.blob()

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("download", filename)
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать файл программы", "error")
            }
            
        },
        NewTheme(e) {
            e.preventDefault()

            let title = this.$refs.theme_title.value
            let mod = this.$refs.theme_module.value
            let type = this.$refs.theme_type.value
            let hour_number = this.$refs.theme_hour_number.value

            let thematicPlan = []

            for (var i in this.currentProgram.Themes) {
                var theme = this.currentProgram.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            thematicPlan.push({
                "number": this.currentProgram.Themes.length > 0 ? Number(this.currentProgram.Themes[this.currentProgram.Themes.length-1].Number) + 1 : 1,
                "title": title,
                "type": type,
                "volume": Number(hour_number),
                "module": Number(mod)
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentProgram.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Новая тема успешно добавлена", "success")
                let index = this.programs.indexOf(this.currentProgram)
                this._ProccessPrograms().then(()=>{this.SeeProgramThemes(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeTheme(e) {
            e.preventDefault()

            let title = this.$refs.current_theme_title.value
            let mod = this.$refs.current_theme_module.value
            let type = this.$refs.current_theme_type.value

            let thematicPlan = []

            let index = this.currentProgram.Themes.indexOf(this.currentTheme)

            for (var i in this.currentProgram.Themes) {

                var theme = this.currentProgram.Themes[i]

                if (i == index) {
                    thematicPlan.push({
                        "id": theme.ID,
                        "number": Number(i) + 1,
                        "title": title,
                        "type": type,
                        "volume": 1,
                        "module": Number(mod)
                    })
                    continue
                }
                
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentProgram.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные темы успешно изменены", "success")
                let index = this.programs.indexOf(this.currentProgram)
                this._ProccessPrograms().then(()=>{this.SeeProgramThemes(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeThemePosition(e) {
            e.preventDefault()

            let position = Number(this.$refs.current_theme_position.value) - 1
            let old_position = this.currentProgram.Themes.indexOf(this.currentTheme)

            if (position >= this.currentProgram.Themes.length) {
                this.$root.ShowToast("Невозможно произвести замену: элемент с таким номером не найден", "error")
            }

            let thematicPlan = []

            for (var i in this.currentProgram.Themes) {
                var theme = this.currentProgram.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }
            
            let old_item = JSON.parse(JSON.stringify(thematicPlan[old_position]))
            let new_item = JSON.parse(JSON.stringify(thematicPlan[position]))

            thematicPlan[position] = old_item
            thematicPlan[position].number = Number(position) + 1
            thematicPlan[old_position] = new_item
            thematicPlan[old_position].number = Number(old_position) + 1

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentProgram.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Замена полей успешно произведена", "success")
                let index = this.programs.indexOf(this.currentProgram)
                this._ProccessPrograms().then(()=>{this.SeeProgramThemes(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteTheme(index) {
            let thematicPlan = []

            for (var i in this.currentProgram.Themes) {

                if (i == index) continue
                var theme = this.currentProgram.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": i > index ? Number(i) : Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentProgram.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Тема успешно удалена", "success")
                let index = this.programs.indexOf(this.currentProgram)
                this._ProccessPrograms().then(()=>{this.UpdateCurrentProgram(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteMultipleThemes() {
            
            function DeleteTheme(thematic_plan, index) {

                let thematicPlan = []
                for (var i in thematic_plan) {

                    if (i == index) continue
                    var theme = thematic_plan[i]
                    thematicPlan.push({
                        "id": theme.id,
                        "number": i > index ? Number(i) : Number(i) + 1,
                        "title": theme.title,
                        "type": theme.type,
                        "volume": 1,
                        "module": theme.module
                    })
                }

                return thematicPlan
            }

            let themes_to_delete = []
            for (var i in this.currentProgram.Themes) {
                var inp = this.$refs[`delete_theme_${i}`][0]
                if (inp !== undefined && inp !== null) if (inp.checked) themes_to_delete.push(Number(i))
            }

            let thematicPlan = []

            for (var i in this.currentProgram.Themes) {
                var theme = this.currentProgram.Themes[i]
                thematicPlan.push({
                    "id": theme.ID,
                    "number": Number(i) + 1,
                    "title": theme.Title,
                    "type": theme.Type,
                    "volume": 1,
                    "module": theme.Module
                })
            }

            themes_to_delete.forEach((value, index)=>{
                thematicPlan = DeleteTheme(thematicPlan, value)

                for (var j = index + 1; j < themes_to_delete.length; j++) themes_to_delete[j] -= 1
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/programs/thematic_plan/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentProgram.ID,
                    themes: thematicPlan
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Выбранные темы успешно удалены", "success")
                let index = this.programs.indexOf(this.currentProgram)
                this._ProccessPrograms().then(()=>{this.UpdateCurrentProgram(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000)
                this.$router.push({name: 'Home'})
                return
            }
            this._ProccessPrograms().then(()=>{
                this.$root.EndLoading()
            })
            this._SelectData()
        })   
    }
}
</script>